import { render, staticRenderFns } from "./percentages.vue?vue&type=template&id=c6f33f22&"
import script from "./percentages.vue?vue&type=script&lang=js&"
export * from "./percentages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports